import React from 'react';
import type { CollapseProps as AntdCollapseProps } from 'antd';

import { Collapse } from './styled.ts';

export type BaseCollapseMotionStyleHandler = (element: HTMLElement) => React.CSSProperties;
export type BaseCollapseMotionEndHandler = (
    element: HTMLElement,
    event: (TransitionEvent | AnimationEvent) & { deadline?: boolean },
) => boolean;

// Open/close motion of a panel. antd forwards it to the inner `@rc-component/collapse` (`CSSMotionProps`),
// but it is not part of antd's own typed Collapse API.
export interface BaseCollapseOpenMotion {
    motionName: string;
    motionAppear?: boolean;
    motionDeadline?: number;
    onEnterStart?: BaseCollapseMotionStyleHandler;
    onEnterActive?: BaseCollapseMotionStyleHandler;
    onEnterEnd?: BaseCollapseMotionEndHandler;
    onLeaveStart?: BaseCollapseMotionStyleHandler;
    onLeaveActive?: BaseCollapseMotionStyleHandler;
    onLeaveEnd?: BaseCollapseMotionEndHandler;
}

export interface BaseCollapseProps extends AntdCollapseProps {
    openMotion?: BaseCollapseOpenMotion;
}

export const BaseCollapse: React.FC<BaseCollapseProps> = ({ className, ...props }) => (
    <Collapse className={className} {...props} />
);
